import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, tap } from 'rxjs';
import { IParams } from '../model/http';
import { IContact } from '../interfaces';
export const initItemsParams: IParams = {
  sort: '',
  order: '',
  search: '',
  take: 25,
  page: 1,
};

export interface IItemsApiResponse {
  items?: any[];
  total?: number;
  size?: number;
  page?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  constructor(
    private readonly http: HttpClient,
  ) { }
  private readonly itemsSubject$ = new BehaviorSubject<any>({});
  public readonly items$ = this.itemsSubject$.asObservable();

  public readonly isLoader$ = new BehaviorSubject<boolean>(false);

  public queryItemsParams = { ...initItemsParams };

  create(payload: any){
    return this.http.post<any>(environment.baseURL + '/contacts', payload)
      .pipe(map(v => v.data));
  }

  getAll(params: any) {
    return this.http.get<any>(environment.baseURL + '/contacts', { params })
      .pipe(map(v => v.data));
  }

  getById(id: string) {
    const url = environment.baseURL + `/contacts/${id}`;
    return this.http.get<any>(url).pipe(map(v => v.data));
  }

  loadItems() {
    this.isLoader$.next(true);
    return this.getAll(this.queryItemsParams)
      .pipe(tap((items) => {
        this.itemsSubject$.next(items);
        this.isLoader$.next(false);
      }));
  }

  setQueryItemsParams(params: IParams) {
    const { sort, order, search, take, page } = params;
    this.queryItemsParams = {
      sort: sort || typeof (sort) === 'string' ? sort : this.queryItemsParams.sort,
      order: order || typeof (order) === 'string' ? order : this.queryItemsParams.order,
      search: search || typeof (search) === 'string' ? search : this.queryItemsParams.search,
      take: take || this.queryItemsParams.take,
      page: page || this.queryItemsParams.page,
    };
    return this.loadItems();
  }

  update(id: string, payload: any){
    const url = environment.baseURL + `/contacts/${id}`;
    return this.http.put(url, payload);
  }

  delete(id: string) {
    return this.http.delete(environment.baseURL + `/contacts/${id}`);
  }

  destroy() {
    this.queryItemsParams = {...initItemsParams};
  }
}
